export enum CAPPLAN_TABS {
  OVERVIEW = 'OVERVIEW',
  WORK_DEMAND = 'WORK_DEMAND',
  BASE_PLAN = 'BASE_PLAN',
  FORMATION = 'FORMATION',
  FLEX_FORECAST = 'FLEX_FORECAST',
  BORROW_AND_LEND = 'BORROW_AND_LEND',
  GROSS_NET = 'GROSS_NET'
}
